export function groupRows<T>(
  rows: T[],
  getKey: (row: T, index: number) => string,
) {
  const groups = new Map<string, { key: string; rows: T[] }>();
  rows.forEach((row, index) => {
    const key = getKey(row, index);
    const group = groups.get(key);
    if (group) group.rows.push(row);
    else groups.set(key, { key, rows: [row] });
  });
  return Array.from(groups.values());
}
